<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow
      class="py-2 py-md-0"
    >
      <!-- Student Avatar -->
      <BCol cols="12">
        <div class="d-flex align-items-center gap-3 bg-white rounded-4 p-4 shadow-sm mb-3">
          <div
            class="d-flex align-items-center justify-content-center rounded-circle"
            style="width: 72px; height: 72px; min-width: 72px; background: linear-gradient(135deg, #3b82f6, #2563eb); color: #fff; font-size: 1.75rem; font-weight: 700;"
          >
            {{ initials }}
          </div>
          <div>
            <h5
              class="fw-bold mb-0"
              style="color: #1e293b;"
            >
              {{ currentUser.name }}
            </h5>
            <p
              class="mb-0 small"
              style="color: #64748b;"
            >
              {{ currentUser.id_number }} &bull; {{ currentUser.course }} &bull; Year {{ currentUser.year_level }}
            </p>
          </div>
        </div>
      </BCol>

      <!-- Tabs -->
      <BCol cols="12">
        <BOverlay
          :show="state.busy"
          opacity="0.5"
        >
          <BCard class="border mt-2 min-h-450px">
            <BCardText>
              <BTabs
                v-model="currentTabIndex"
                active-nav-item-class="text-primary"
                nav-class="scrollable-x-tabs no-scrollbar nav-representative-tabs gap-x-1"
                pills
              >
                <template #tabs-start>
                  <div class="nav-item">
                    <div
                      class="d-flex align-items-center position-absolute"
                      style="padding: 2px 1px; height: 38px;"
                    >
                      <i
                        class="fas fa-chevron-left bg-primary-light p-1 rounded-lg"
                        style="font-size: 20px;"
                      />
                    </div>
                  </div>
                </template>
                <template #tabs-end>
                  <div class="nav-item">
                    <div
                      class="d-flex align-items-center position-absolute"
                      style="right: 20px; padding: 2px 1px; height: 38px;"
                    >
                      <i
                        class="fas fa-chevron-right bg-primary-light p-1 rounded-lg"
                        style="font-size: 20px;"
                      />
                    </div>
                  </div>
                </template>
                <BTab>
                  <template #title>
                    <i :class="iconState('fa-file-user', currentTabIndex === 0)" /> Info
                  </template>

                  <BContainer
                    class="h-100 p-0"
                    fluid
                  >
                    <StudentInformations :user="currentUser" />
                  </BContainer>
                </BTab>
                <BTab lazy>
                  <template #title>
                    <i :class="iconState('fa-key', currentTabIndex === 1)" /> Change Password
                  </template>

                  <BContainer
                    class="h-100 p-0"
                    fluid
                  >
                    <StudentChangePassword />
                  </BContainer>
                </BTab>
              </BTabs>
            </BCardText>
          </BCard>
        </BOverlay>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script>
import { mapGetters } from 'vuex'

import StudentInformations from '@/views/student/account-settings/Informations.vue'
import StudentChangePassword from '@/views/student/account-settings/ChangePassword.vue'

import MxMisc from '@/mixins/misc'

export default {
  name: 'VStudentAccountSettings',

  components: {
    StudentInformations,
    StudentChangePassword
  },

  mixins: [MxMisc],

  middleware: ['auth', 'student'],

  metaInfo: () => ({
    title: 'Account Settings'
  }),

  data () {
    return {
      state: {
        busy: false
      },
      currentTabIndex: 0
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    initials () {
      if (!this.currentUser) return ''
      const first = this.currentUser.first_name?.charAt(0) || ''
      const last = this.currentUser.last_name?.charAt(0) || ''
      return `${first}${last}`.toUpperCase()
    }
  },

  mounted () {
    if (this.currentUser) {
      this.$nextTick(() => {
        this.attachArrowScroller('.nav-representative-tabs')
      })
    }
  },

  destroyed () {
    this.detachArrowScroller('.nav-representative-tabs')
  }
}
</script>
